import React from 'react';
import styles from './styles.module.css';
import parts from '../moduleCard/moduleParts.module.css';
import MealCard from './MealCard';
import { EXAMPLE_GUIDELINES, EXAMPLE_MEALS } from './mealPlanExampleData';

/**
 * Estado vazio do módulo: um plano ilustrativo esmaecido com a etiqueta
 * "Exemplo", para o profissional ver como o plano chega ao paciente.
 * Nada aqui é clicável.
 */
const MealPlanExample = () => (
  <div className={styles.example} aria-label="Exemplo de plano alimentar, sem dados do paciente">
    <div className={styles.exampleHead}>
      <span className={`${parts.chip} ${parts.chipAccent}`}>Exemplo</span>
      <span className={parts.muted}>
        Nenhum plano montado. Assim fica o plano depois do primeiro: as refeições abaixo são ilustrativas.
      </span>
    </div>
    <div className={styles.exampleBody} aria-hidden="true">
      <div className={styles.content}>
        <div className={styles.meals}>
          {EXAMPLE_MEALS.map((meal) => <MealCard key={meal.key} meal={meal} />)}
        </div>
        <div className={styles.guidelines}>
          <span className={parts.sectionLabel}>Orientações gerais</span>
          <span className={parts.itemText}>{EXAMPLE_GUIDELINES}</span>
        </div>
      </div>
    </div>
  </div>
);

export default MealPlanExample;
